angular.module('controllers').controller('localityController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval) {
		$rootScope.path = '/locality';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'locality';
		$scope.pathTemplate = 'distribution/localities';
		$scope.title = 'Localitati';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'street_no';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'county_name':{'label':'Judet', 'filter':1, 'filterType':'input'},
			'locality_name':{'label':'Localitate', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'locality_name';
		$scope.additionals['jsonPath'] = '/json';

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.additionals['getCounties'] = function () {
			Crud.get($scope.additionals['jsonPath'] + '/counties.json')
				.success(function (data) {
					$scope.additionals['counties'] = data;
				});
		}
		$scope.additionals['getCounties']();

		if (angular.isUndefined($scope.search.county)) {
			$scope.search.county_name = 'Cluj';
		}

		$scope.additionals['function']= function(ev, model) {
			if($scope.action == 'store') {
				if (angular.isUndefined(model.county)) {
					model.county_name = 'Cluj';
				}
			}
		}

		$scope.additionals['internFunction']= function(ev, model) {

		}

        $scope.additionals['functionResult']= function(ev, data) {
            if($scope.action == 'update' || $scope.action == 'store') {
                if (!angular.isUndefined($scope.modelData.locality_name)) {
                    $scope.modelData.locality_name = $scope.additionals['formatTextResult']($scope.modelData.locality_name);
                }
            }
            if($scope.action == 'updatemultiple') {
                if (!angular.isUndefined($scope.modelsData)) {
                    angular.forEach($scope.modelsData, function (item, key) {
                        if (item.selected !== false) {
                            if (!angular.isUndefined($scope.modelsData[key].locality_name)) {
                                $scope.modelsData[key].locality_name = $scope.additionals['formatTextResult']($scope.modelsData[key].locality_name);
                            }

                        }
                    });
                }

            }
        }


	}]
);
